import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { productsData, lineupData, reportData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger } from './common/k-tools/k-tools.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const swiperHandler = {};
swiperHandler.feature = function () {
  let featureSwiper;
  function featureSwiperInit() {
    featureSwiper = new Swiper('.feature__swiper', {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: '.feature__swiper .swiper-button-next',
        prevEl: '.feature__swiper .swiper-button-prev',
      },
      pagination: {
        el: '.feature__swiper .swiper-pagination',
        clickable: true,
      },
    });
  }

  function checkScreenWidth() {
    const viewWidth = window.innerWidth;
    if (viewWidth < 992) {
      featureSwiperInit();
    } else {
      if (featureSwiper) {
        featureSwiper.destroy(true, true);
        featureSwiper = null;
      }
    }
  }

  checkScreenWidth();
  $(window).on('resize', checkScreenWidth);
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });

  gsapAnimation();
  swiperHandler.feature();
};

// Vue
createApp({
  setup() {
    const productsDataRef = ref(productsData);
    const lineupDataRef = ref(lineupData);
    const reportDataRef = ref(reportData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      productsDataRef,
      lineupDataRef,
      reportDataRef,
    };
  },
}).mount('#main');
